/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetLoanQueryResponse, GetLoanPathParams, GetLoan400, GetLoan401, GetLoan403, GetLoan404, GetLoan409, GetLoan500 } from "../../types/financialHubController/GetLoan.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetLoanUrl(organizationId: GetLoanPathParams["organizationId"], loanId: GetLoanPathParams["loanId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/financial/loans/${loanId}` as const }
  return res
}

/**
 * @summary Get a loan with its full installment schedule
 * {@link /api/organizations/:organizationId/financial/loans/:loanId}
 */
export async function getLoan(organizationId: GetLoanPathParams["organizationId"], loanId: GetLoanPathParams["loanId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetLoanQueryResponse, ResponseErrorConfig<GetLoan400 | GetLoan401 | GetLoan403 | GetLoan404 | GetLoan409 | GetLoan500>, unknown>({ method : "GET", url : getGetLoanUrl(organizationId, loanId).url.toString(), ... requestConfig })
  return res.data
}